module.exports = __webpack_public_path__ + "static/media/download_icon.062cb5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download_icon.png
// module id = 156
// module chunks = 0